﻿import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';

export default class TKFavoriteInfo extends TKCustomElementFactory {
    anchor?: HTMLAnchorElement;
    counter?: HTMLSpanElement;
    href: string;
    quantity: number;
    isMulti: boolean;
    emptyClassName: string;

    static observedAttributes = ['data-tk-quantity'];

    constructor() {
        super();
        this.anchor = this.querySelector('a') || undefined;
        this.counter = this.anchor?.querySelector('[data-tk-counter-info') || undefined;
        this.quantity = Number(this.getAttribute('data-tk-quantity'));
        this.isMulti = this.hasAttribute('data-tk-is-multi');
        this.href = this.getAttribute('data-tk-href') || '';
        this.emptyClassName = this.getAttribute('data-tk-empty-class-name') || 'tk-button__counter--empty';
    }

    attributeChangedCallback(name: string, _oldValue: string, newValue: string) {
        if (name === 'data-tk-quantity' && this.counter) {
            if (!this.anchor) return;
            this.anchor.setAttribute('data-count', newValue);
            if (Number(newValue) === 0) {
                this.counter?.classList.add(this.emptyClassName);
            } else {
                this.counter?.classList.remove(this.emptyClassName);
                this.counter.textContent = newValue;
            }
        }
    }
}
